 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"00aa5ec91484200ebae4539d124621a4c0ae073b","3":"2fe454eb43ef5d9bb0bb87b43c87706ffeecd892","4":"40b72ecc2a5accc75505486bc26963c7c3b80314","5":"841b02cfb9bcee3ef27fe7f103f51795a4c4c5ae","6":"834b794a2fa97d63fcd1d48709d635bc2bbabd88","10":"component---src-pages-approach-js","11":"component---src-pages-become-a-carer-js","12":"component---src-pages-blog-js","13":"component---src-pages-care-consultation-js","14":"component---src-pages-companionship-care-js","15":"component---src-pages-condition-cancer-js","16":"component---src-pages-condition-dementia-js","17":"component---src-pages-condition-multiple-sclerosis-js","18":"component---src-pages-condition-parkinsons-js","19":"component---src-pages-condition-stroke-js","20":"component---src-pages-cookies-js","21":"component---src-pages-couples-care-js","22":"component---src-pages-cta-js","23":"component---src-pages-editorial-policy-js","24":"component---src-pages-index-js","25":"component---src-pages-live-in-care-south-east-london-js","26":"component---src-pages-liveincare-js","27":"component---src-pages-liveincare-looking-for-care-js","28":"component---src-pages-our-carers-js","29":"component---src-pages-our-team-js","30":"component---src-pages-partner-with-us-js","31":"component---src-pages-pricing-js","32":"component---src-pages-privacy-js","33":"component---src-pages-privacy-version-1-0-js","34":"component---src-pages-request-a-brochure-js","35":"component---src-pages-social-media-studio-js","36":"component---src-pages-terms-and-conditions-js","37":"component---src-templates-author-js","38":"component---src-templates-blog-post-js","39":"component---src-templates-location-js"}[chunkId]||chunkId) + "-" + {"0":"3575ca66b5099a8828bf","1":"e9d24b1846c7d6eb9685","2":"023619baaf159d157387","3":"7f42a0b1522d18d8319e","4":"b1525ee820eca981034e","5":"51824ac4820459ad80ab","6":"b0bf34f908f3696dfc48","8":"eb60db59fe726b794854","10":"f80b04ba05f684762cbe","11":"555de172ce866f992fc5","12":"497396372f664333db26","13":"14fd8147b55cb8435afe","14":"786db91724ff8c8b39a7","15":"4a623a77cbb4b973e7d0","16":"c3d6c30db6c4fdb7c365","17":"7f3c07ec352d3923d8e3","18":"d34a0f4c93b14a26f00d","19":"608b7dc700c8cf5cba63","20":"ea3c4c0bcadf1f6522f0","21":"3f8b3f825742aa7d8a6a","22":"100fb8fca31670ae42b5","23":"901a0963b9e92794d240","24":"2b3fb10c4362bfc40e3e","25":"a4d42878f49c207eed26","26":"b1b89aafab7e3419798d","27":"ad617d6a6386415bf5b3","28":"e04447f5f4c4decd48d3","29":"16735194a040e3dad2a4","30":"4052400d15c89597f66d","31":"53358e36d805a2230ca5","32":"715564acaba21328a37d","33":"bad1cbd8f8e3ee6e24ea","34":"d2ef9984128c383cd152","35":"a58961b1279cde977b16","36":"dce6e73d70793f7b6482","37":"2067d89f1a98d3cae52a","38":"c0cea673fc3b2b2d8b6f","39":"1e3f89339fc5fe908ab0","42":"b10a866a1628b32dc743","43":"c55df51dce9a8d9ea3a5","44":"d61ccc3630c8c6263f53"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"00aa5ec91484200ebae4539d124621a4c0ae073b","3":"2fe454eb43ef5d9bb0bb87b43c87706ffeecd892","4":"40b72ecc2a5accc75505486bc26963c7c3b80314","5":"841b02cfb9bcee3ef27fe7f103f51795a4c4c5ae","6":"834b794a2fa97d63fcd1d48709d635bc2bbabd88","10":"component---src-pages-approach-js","11":"component---src-pages-become-a-carer-js","12":"component---src-pages-blog-js","13":"component---src-pages-care-consultation-js","14":"component---src-pages-companionship-care-js","15":"component---src-pages-condition-cancer-js","16":"component---src-pages-condition-dementia-js","17":"component---src-pages-condition-multiple-sclerosis-js","18":"component---src-pages-condition-parkinsons-js","19":"component---src-pages-condition-stroke-js","20":"component---src-pages-cookies-js","21":"component---src-pages-couples-care-js","22":"component---src-pages-cta-js","23":"component---src-pages-editorial-policy-js","24":"component---src-pages-index-js","25":"component---src-pages-live-in-care-south-east-london-js","26":"component---src-pages-liveincare-js","27":"component---src-pages-liveincare-looking-for-care-js","28":"component---src-pages-our-carers-js","29":"component---src-pages-our-team-js","30":"component---src-pages-partner-with-us-js","31":"component---src-pages-pricing-js","32":"component---src-pages-privacy-js","33":"component---src-pages-privacy-version-1-0-js","34":"component---src-pages-request-a-brochure-js","35":"component---src-pages-social-media-studio-js","36":"component---src-pages-terms-and-conditions-js","37":"component---src-templates-author-js","38":"component---src-templates-blog-post-js","39":"component---src-templates-location-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f4e18180ef9b4e832927","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
